import { IDashboardAPIResponse } from "../types/dashboard.types";

export const INITIAL_DASHBOARD_STATE: IDashboardAPIResponse = {
  result: {
    totalFines: 0,
    finesByType: {},
    totalCollections: 0,
    collectionsByType: {},
    outstandingPayments: 0,
    outstandingByType: {},
    finesTrend: [],
    collectionTrend: [],
    todaysFines: 0,
    mtdFines: 0,
    ytdFines: 0,
    balanceAmount: 0,
    collectionAmount: 0,
    todayCollection: 0,
    mtdCollection: 0,
    ytdCollection: 0,
  },
  loading: false,
};
